import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const PublicCatalogPageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "PublicCatalogPage" */'../PublicCatalogPage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default PublicCatalogPageLoadable;